import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import type { ThemePreference } from '../contexts/theme-utils';
import { userPreferencesService } from '../services/userPreferencesService';

// Ordem de ciclagem ao clicar: Claro → Escuro → Sistema → Claro …
const ORDER: ThemePreference[] = ['light', 'dark', 'system'];

const META: Record<ThemePreference, { label: string; Icon: typeof Sun }> = {
  light: { label: 'Claro', Icon: Sun },
  dark: { label: 'Escuro', Icon: Moon },
  system: { label: 'Sistema', Icon: Monitor },
};

/**
 * Item de menu (dropdown do perfil) que alterna o tema a cada clique, ciclando
 * entre Claro, Escuro e Sistema. O label é o próprio tema atual. Não fecha o
 * dropdown, então dá pra clicar várias vezes até chegar no tema desejado.
 */
export const ThemeToggle = () => {
  const { preference, setPreference } = useTheme();
  const { label, Icon } = META[preference];

  const cycle = () => {
    const next = ORDER[(ORDER.indexOf(preference) + 1) % ORDER.length];
    setPreference(next); // aplica na hora + cacheia no localStorage (anti-flash)
    // Persiste por usuário (user_preferences). Best-effort: o localStorage já cobre.
    userPreferencesService.update({ theme: next }).catch(() => {
      /* offline / sem sessão: mantém só o cache local */
    });
  };

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Alternar tema, atual: ${label}`}
      title="Alternar tema"
      className="w-full flex items-center gap-2 px-2 py-1.5 text-sm text-body/80 hover:bg-surface-muted rounded-[5px] transition-colors"
    >
      <Icon className="w-4 h-4 text-body/80" strokeWidth={2.5} />
      <span className="font-medium text-body/80">{label}</span>
    </button>
  );
};

export default ThemeToggle;
